import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useLoginSignUpUiConfiguration() {
  return useCbhFlag(CbhFeatureFlag.CONFIGURE_LOGIN_SIGNUP_UI, {
    defaultValue: { hideFooterAndSecondaryButtonsOnKeyboardOpen: false },
  });
}
